export const LoadingIcon = ({ style }) => {
    return (
        <div className="loading-btn" style={style}>
            <div className="ball one"></div>
            <div className="ball two"></div>
            <div className="ball three"></div>
            <div className="ball four"></div>
        </div>
    )
}